export default __webpack_public_path__ + "static/media/home_explain_export_import@3x.eba9e060.png";